module.exports = __webpack_public_path__ + "img/fun_jqfy.212f8ffa.jpg";